<script>
import { authMethods } from "@/state/helpers";
import { required, email } from "vuelidate/lib/validators";

import Swal from "sweetalert2";
import axios from 'axios';

export default {
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      sendingMail: false,
      success: false,

      form: {
        email: "",
      }
    };
  },
  validations: {
    form: {
      email: { required, email }
    }
  },
  created() {
    document.body.classList.add("auth-body-bg");
  },
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset(e) {
      e.preventDefault();
      let app = this;

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        this.sendingMail = true;

        axios.post(window.serverPath+'dist/mvw/controllers/users.php', {
          request: 'resetPassword',
          data: this.form,
        })
        .then(function (response) {
          if( response.status == 200 ){
            app.sendingMail = false;
            if( response.data.error ){
              app.isResetError = true;
              app.error = response.data.error;
            }else if( response.data == "Ok"){
              app.success = true;
            }
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });
      }
    },
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/">
        <i class="mdi mdi-home-variant h2 text-white"></i>
      </a>
    </div>
    <div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-lg-4">
            <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div class="w-100">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <div class="text-center">
                        <div>
                          <a href="/" class="logo">
                            <!--<img src="@/assets/images/logo-dark.png" height="20" alt="logo" />-->
                            <img src="@/assets/images/logo.png" height="100" alt="EvalsMatter" />
                          </a>
                        </div>

                        <h4 class="font-size-18 mt-4">Reset Password</h4>
                        <!--<p class="text-muted">Reset your password to EvalsMatter.</p>-->
                      </div>

                      <div class="p-2 mt-5">
                        <b-alert
                          v-model="isResetError"
                          class="mb-4"
                          variant="danger"
                          dismissible
                        >{{error}}</b-alert>

                        <form class="form-horizontal" @submit.prevent="tryToReset">
                          <div class="form-group auth-form-group-custom mb-4">
                            <i class="ri-mail-line auti-custom-input-icon"></i>
                            <label for="useremail">Email</label>
                            <input
                              v-model="form.email"
                              type="email"
                              class="form-control"
                              id="useremail"
                              placeholder="Enter email"
                              :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                            />
                            <div v-if="submitted && $v.form.email.$error" class="invalid-feedback">
                              <span v-if="!$v.form.email.required">Email is required.</span>
                              <span v-if="!$v.form.email.email">Please enter valid email.</span>
                            </div>
                          </div>

                          <div class="form-group pt-4">
                            <div v-if="sendingMail" class="text-center">
                              <b-spinner class="small-spinner mr-2" variant="dark" role="status"></b-spinner>
                              <span class="text-muted">Sending reset password request.</span>
                            </div>

                            <div v-if="success" class="text-center">
                              <b-alert show variant="success">Requese sent. Please check your email.</b-alert>
                            </div>
                          </div>

                          <div class="mt-4 text-center">
                            <button
                              class="btn btn-primary w-md waves-effect waves-light"
                              type="submit"
                            >Reset</button>
                          </div>
                        </form>
                      </div>

                      <div class="mt-5 text-center">
                        <!--
                        <p>
                          Don't have an account ?
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                          >Log in</router-link>
                        </p>
                        -->
                        <p>
                          Designed with <i class="mdi mdi-heart text-danger"></i> by CHEETAH STUDIO;<br>
                          Developed with <i class="mdi mdi-flash text-warning"></i> by <span class="text-danger">ICARIASOFT</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="authentication-bg">
              <div class="bg-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css">
  .small-spinner{
    width: 15px !important;
    height: 15px !important;
  }
</style>